import { QueryDispatcher } from "../../shared/domain/QueryDispatcher";

export class CompanyBankAccounts {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(company_id:String|Number, limit:Number, offset:Number): Promise<any> {
    let args = { 
      company_id: company_id,
      limit: limit,
      offset: offset
    }
    this.frontend.loading_bank_accounts(true)
    let data = await this.dispatcher.dispatch('bank_account.data', args)
    this.frontend.loading_bank_accounts(false)
    if (data.status === '200') {
      this.frontend.bank_accounts = data.data
    } else {
      this.frontend.bank_accounts = []
      return 'There is no data for this company id'
    }
  }
}